import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useEffect } from 'react';

const NotFound = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-[#2C2E2D] text-[#D9D9D9]">
      <div className="w-full max-w-md text-center">
        <h1 className="text-[#CCF751] text-8xl font-bold mb-4">404</h1>
        <h2 className="text-2xl font-semibold mb-2">Page Not Found</h2>
        <p className="text-[#818881] mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col gap-4 items-center">
          <Link to="/">
            <Button className="bg-[#CCF751] text-[#2C2E2D] hover:bg-[#CCF751]/90 w-full max-w-xs">
              Back to Home
            </Button>
          </Link>
          <Link to="/dashboard">
            <Button variant="outline" className="border-[#818881] text-[#D9D9D9] hover:bg-[#818881]/20 w-full max-w-xs">
              Go to Dashboard
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 